import { getOrDefault } from '@/utils/map'

export type Unit = 'y' | 'w' | 'd' | 'h' | 'm' | 's' | 'ms'

// TODO: Enable this once ts is updated to >3, template literals are not supported in <4
// export type DurationAtom = `${number}${Unit}`
// export type Duration = `${DurationAtom}${'' | ` ${DurationAtom}`}`

export type Duration = string

export const DURATION_ATOM_REGEX = /\d*(ms|y|w|d|h|m|s)/g
export const DURATION_REGEX = /^((\d*(ms|y|w|d|h|m|s))\s?){1,2}$/g

// based on minutes
export const MULTIPLICATION_TABLE = new Map<Unit, number>([
  ['y', 60 * 24 * 7 * 52],
  ['w', 60 * 24 * 7],
  ['d', 60 * 24],
  ['h', 60],
  ['m', 1],
  ['s', 1 / 60],
  ['ms', 1 / 60000],
])

export function parse (duration: Duration, conversion: Unit = 'm'): number {
  let sum = 0

  duration.match(DURATION_ATOM_REGEX)
    ?.map((durationAtom): { unit: Unit, amount: number } => {
      const units = durationAtom.match(/(ms|y|w|d|h|m|s)/g)
      const amounts = durationAtom.match(/\d*/g)

      if (!units || !amounts) {
        console.debug(`[duration] parse - could not parse duration-atom; unit: ${units}, amount: ${amounts}`)
        return {unit: 'm', amount: 1}
      }

      return {
        unit: units[0] as Unit,
        amount: +amounts[0],
      }
    })
    .forEach(({unit, amount}) => { sum += amount * getOrDefault(MULTIPLICATION_TABLE, unit, 1) })

  return convert(sum, 'm', conversion)
}

export function convert (value: number, original: Unit, to: Unit): number {
  return getOrDefault(MULTIPLICATION_TABLE, original, 1) * value / getOrDefault(MULTIPLICATION_TABLE, to, 1)
}

/* global DurationTime, days, hours, minutes */
export interface DurationTime {
  days: number,
  hours: number,
  minutes: number
}

export function durationTime (duration: number): DurationTime {
  const days = Math.floor(convert(duration, 'm', 'd'))
  const hours = Math.floor(convert(duration, 'm', 'h')) - days * 24
  const minutes = Math.round(duration) - hours * 60 - days * 24 * 60

  return {
    days,
    hours,
    minutes,
  }
}
